import loadable from 'components/dynamic-import';

export const ConnectedCollection = loadable(() => import('./ConnectedCollection'));
